<template>
  <transition
    name="slide"
    enter-active-class="slide-enter-active"
    leave-active-class="slide-leave-active"
    enter-from-class="slide-enter-from"
    enter-to-class="slide-enter-to"
    leave-to-class="slide-leave-to"
  >
    <div
      v-if="toast.show"
      ref="toast"
      :class="`toast-container ${toast.type}`"
    >
      <Vue3Lottie
          class="toast-animation"
          :animationData="animationData"
          :loop="true"
          height="auto"
          :speed="1"
      />
      <div class="toast-text">
        <div class="main-text">{{ toast.mainText }}</div>
        <div class="secondary-text">{{ toast.secondaryText }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie'
import animationData from '@public/resources/lottie/stowyLoader.json';
import { mapState } from 'vuex';

export default {
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      isVisible: false,
      animationData,
    };
  },
  computed: {
    ...mapState({
      toast: state => state.toast
    })
  },

  watch: {
    toast: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.show) {
          this.showToast();
        } else {
          this.resetToastOffset();
        }
        if (oldValue && oldValue.type === 'info' && newValue.type !== 'info') {
          this.hideToastAfterDelay();
        }
      }
    }
  },

  methods: {
    showToast() {
      this.isVisible = true;
      this.$nextTick(() => {
        const height = this.$refs.toast?.offsetHeight || 0;
        this.setToastOffset(height);
      });
      if (this.toast.type !== 'info') {
        this.hideToastAfterDelay();
      }
    },
    setToastOffset(height) {
      document.documentElement.style.setProperty('--toast-offset', `${height}px`);
    },
    resetToastOffset() {
      document.documentElement.style.setProperty('--toast-offset', '0px');
    },
    hideToastAfterDelay() {
      if (this.toast.type === 'info') {
        return;
      }
      setTimeout(() => {
        if (this.toast.type !== 'info') {
          this.isVisible = false;
          this.$store.commit('hideToast');
          this.resetToastOffset();
        } else {
        }
      }, 5000);
    },
  },

  beforeUnmount() {
    this.resetToastOffset();
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 0;
  left:0;
  width: 100%;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-tooltip);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-enter-from, .slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.toast-animation {
  flex: 1;
  max-width:140px;
}

.toast-text {
  color: white;
  text-shadow: 1px 1px 2px black;
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 20px;
}

.main-text {
  font-size: min(6.5vw,32.5px);
}

.secondary-text {
  font-size: min(3.9vw,20px);
}

.success {
  background-color: #bdd96a;
}

.info {
  background-color: #4da0ff;
}

.error {
  background-color: #ee7d15;
}
</style>
